<template>
	<div class="mt-4 grid gap-y-4 gap-x-4">
		<label
			v-for="(option, idx) in localOptions"
			:key="idx + '-' + option.checked"
			:class="[
				option.checked
					? 'border-transparent ring-2 ring-orange-500'
					: 'border-gray-300',
				'relative bg-white border rounded-lg shadow-sm p-2 sm:p-3 flex cursor-pointer focus:outline-none',
			]"
			@click="toggle(idx)"
		>
			<div class="flex-1 flex">
				<div
					class="flex flex-col"
					:class="[option.icon ? 'text-center space-y-3 justify-between' : '']"
				>
					<ui-icon
						v-if="option.icon"
						:name="option.icon"
						class="max-h-[5rem]"
					/>
					<span
						id="project-type-0-label"
						class="block font-medium text-gray-900 truncate"
						>{{ __(option.name_short) || __(option.label) }}</span
					>
				</div>
			</div>
			<!--
        Not Checked: "invisible"

        Heroicon name: solid/check-circle
            -->
			<svg
				class="h-5 w-5 text-orange-500"
				:class="[option.icon ? 'absolute top-4 right-4' : 'flex-shrink-0']"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 20 20"
				fill="currentColor"
				aria-hidden="true"
				v-if="option.checked"
			>
				<path
					fill-rule="evenodd"
					d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
					clip-rule="evenodd"
				/>
			</svg>

			<div
				:class="[
					option.checked
						? 'border border-orange-500'
						: 'border-2 border-transparent',
					'absolute -inset-px rounded-lg pointer-events-none',
				]"
				aria-hidden="true"
			></div>
		</label>
	</div>
</template>
<script>
import Vue from "vue";

export default {
	props: {
		value: {
			type: Array,
			required: false,
			default: () => [],
		},
		options: {
			type: Array,
			required: true,
		},
	},
	data() {
		let selected = this.value || [];
		return {
			localOptions: Vue.observable(
				this.options.map(function (o) {
					o["checked"] = selected.includes(o.value);
					return o;
				})
			),
		};
	},
	methods: {
		toggle(idx) {
			let v = this.localOptions[idx];
			v.checked = !v.checked;

			Vue.set(this.localOptions, idx, v);
			//console.log('TOGGLED, now EMIT');
			this.emitUpdate();
		},
		emitUpdate() {
			let s = this.localOptions.filter((o) => o.checked).map((o) => o.value);
			this.$emit("input", s);
			console.log("ButtonSelect $input", s);
		},
		clearSelection: function () {
			this.localOptions = Vue.observable(
				this.localOptions.map(function (option) {
					option["checked"] = 0;
					return option;
				})
			);
		},
	},
};
</script>
